const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "LINK", "META", "TEMPLATE"]);
function getHeaderHeight() {
    const fromCss = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height") || "0");
    if (!Number.isNaN(fromCss) && fromCss > 0) {
        return fromCss;
    }
    const header = document.querySelector("[data-component='Header'], header");
    return header?.offsetHeight ?? 0;
}
function isMeaningfulSection(el) {
    if (SKIP_TAGS.has(el.tagName)) {
        return false;
    }
    const style = getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") {
        return false;
    }
    // Prefer visible layout boxes; allow zero-height wrappers that still contain content
    return el.getBoundingClientRect().height > 1 || el.childElementCount > 0;
}
/**
 * Find the next page section below the hero/carousel.
 * Walks up from the button until a meaningful next sibling is found.
 * Prefer the carousel root when the hero sits inside a CarouselSlider.
 */
function findNextSection(from) {
    const carousel = from.closest("[data-component='CarouselSlider'], .carousel-right-preview, .carousel-block-v2, .carousel-left-right-preview");
    let current = carousel ?? from.closest("[data-hero-banner]") ?? from;
    while (current && current !== document.body) {
        let sibling = current.nextElementSibling;
        while (sibling) {
            if (isMeaningfulSection(sibling)) {
                return sibling;
            }
            sibling = sibling.nextElementSibling;
        }
        current = current.parentElement;
    }
    return null;
}
function scrollToSection(target) {
    const headerHeight = getHeaderHeight();
    const offset = headerHeight;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
}
export const HeroScrollIndicator = (element) => {
    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const nextSection = findNextSection(element);
        if (nextSection) {
            scrollToSection(nextSection);
        }
    };
    element.addEventListener("click", handleClick);
    return () => {
        element.removeEventListener("click", handleClick);
    };
};
export default HeroScrollIndicator;
